<template lang="pug">
v-menu(ref="menuRef"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y full-width lazy
      min-width="290px"
      :disabled="disabled")
  v-text-field(ref="textRef" :label="label" :value="formattedDate" v-model="formattedDate" :hint="hint" :persistent-hint="persistentHint" slot="activator" :readonly="readonly" :box="box" :rules="rules" :disabled="disabled" @blur="parseDate(formattedDate)" v-mask="'##-##-####'")
    template(slot="prepend" v-if="prependIcon")
      v-icon(:color="prependIconColor") {{ prependIcon }}
    template(slot="prepend-inner" v-if="prependInnerIcon")
      v-icon(:color="prependInnerIcon") {{ prependInnerIcon }}
  v-date-picker(v-model="date" first-day-of-week="1" :locale="locale" :min="minDate" :max="maxDate" no-title @input="dateSelected" :disabled="disabled")
</template>

<script>
import { getLocale } from '@/i18n'
import { mapActions } from 'vuex'

export default {
  name: 'DatePicker',
  props: {
    value: {
      type: [Date],
      default: null,
    },
    rules: {
      type: Array,
      default: function init() {
        return []
      },
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY',
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    min: {
      type: Date,
      default: null,
    },
    max: {
      type: Date,
      default: null,
    },
    box: {
      type: Boolean,
      default: false,
    },
    prependIcon: {
      type: String,
      default: null,
    },
    prependInnerIcon: {
      type: String,
      default: null,
    },
    prependIconColor: {
      type: String,
      default: 'grey darken-1',
    },
  },

  data() {
    return {
      date: null,
      formattedDate: null,
      minDate: null,
      maxDate: null,
    }
  },

  computed: {
    locale() {
      return getLocale()
    },
  },

  watch: {
    'value'(value) {
      this.date = value.toJSON()
      this.formattedDate = this.$moment(value).format(this.format)
      if (this.maxDate && this.$moment(this.$moment(value)).isAfter(this.maxDate, 'day')) {
        this.setSnackbar(`Больше максимальной даты: ${this.$moment(this.maxDate).format('DD-MM-YYYY')}`)
      }
      if (this.minDate && this.$moment(this.$moment(value)).isBefore(this.minDate, 'day')) {
        this.setSnackbar(`Меньше минимальной даты: ${this.$moment(this.minDate).format('DD-MM-YYYY')}`)
      }
    },
  },

  created() {
    if (this.value) {
      this.date = this.value.toJSON()
      this.formattedDate = this.$moment(this.value).format(this.format)
    }
    if (this.min) {
      this.minDate = this.$moment(this.min).format('YYYY-MM-DD')
    }
    if (this.max) {
      this.maxDate = this.$moment(this.max).format('YYYY-MM-DD')
    }
  },

  methods: {
    ...mapActions({
      setSnackbar: 'tools/setSnackbar',
    }),

    dateSelected(date) {
      console.log('date: ' + date);
      this.formattedDate = this.$moment(date).format(this.format)
      this.$refs.menuRef.save(date)
      this.$emit('input', new Date(date))
    },

    parseDate (date) {
      if (date){
        let current = this.$moment(this.date).format(this.format)
        if(date !== current){
          const [day, month, year] = date.split('-')
          if(day && month && year){
            const newDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            this.formattedDate = this.$moment(newDate).format(this.format)
            this.$refs.menuRef.save(newDate)
            this.$emit('input', new Date(newDate))
          } else {
            this.formattedDate = undefined;
            this.date = undefined;
          }
        }
      } else {
        this.formattedDate = undefined;
        this.date = undefined;
      }
    }
  },
}
</script>

<style lang="stylus">
</style>


// WEBPACK FOOTER //
// src/components/utils/DatePicker.vue